import React, { useState, useCallback, useRef } from 'react'
import AuthLayout from './auth-layout'
import LoginMobile from 'custom/assets/landing/login-mobile.svg'
import { Formik, Form } from 'formik'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import { LoginSchema, VerifySchema } from '../../schemas/auth'
import NeoButton from '../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import { getProfileImage, getUserDetails } from '../../services/auth.service'
import {
  setCompanyDetails,
  setLoginDetails,
  setMenuDetails,
  setRoleAccessDetails,
  setRoleAccessKey,
  setUserDetails,
} from '../../store/actions/app.actions'
import AuthService from '../../services/auth.service'
import { VERIFY_CODE_KEYS, BUTTON_KEYS, LOGIN_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import NeoOTPVerify from '../../components/FormComponents/NeoOtpVerify'
const loginConfig = validationConfig['login']

export default function Verify() {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const [error, setError] = useState('Error Placeholder')
  const { t } = useTranslation()
  const [otp, setOtp] = useState('')

  const onSubmit = useCallback(
    async (values) => {
      try {
        setLoading(true)
        const response = await AuthService.verifyLoginOTP({ otp: otp })

        if (response.status === 200) {
          await getAllMenus()
          await getRights()
          getProfileImage()
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        setOtp('')
        // setError(err)
        // //showModal()
      }
    },
    [otp],
  )

  const getAllMenus = useCallback(async (values) => {
    try {
      const response = await AuthService.getAllMenus(values)
      if (response.status === 200) {
        dispatch(setMenuDetails(response.data['menus']))
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  const getRights = useCallback(async (values) => {
    try {
      const response = await AuthService.getRights(values)
      if (response.status === 200) {
        const accessKeys = Object.keys(response.data['acccessList'])
        dispatch(setRoleAccessKey(accessKeys[0]))
        dispatch(setUserDetails(response.data['user']))
        dispatch(setRoleAccessDetails(response.data['acccessList']))
        dispatch(setCompanyDetails(response.data['company']))

        if (response.data['user'].newPwdFlg === 'Y') {
          history.push('/resetPassword')
          return
        }
        history.push('/dashboard')
      }
    } catch (err) {
      console.error(err)
    }
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='45px' height='45px' />
      </div>
    )
  }

  return (
    <AuthLayout>
      <h2 className='app-name'>{t(LOGIN_KEYS.APP_NAME)}</h2>
      <div className='text-center'>
        <img
          className=''
          style={{ margin: '0 auto' }}
          src={LoginMobile}
          alt='mobile logo'
          height='100'
        />
      </div>

      <div className='mx-auto' style={{ width: 350 }}>
        <NeoOTPVerify setOTP={setOtp} otp={otp} onSubmit={onSubmit} loading={loading} />
        {/* <Formik initialValues={{ otp: '' }} validationSchema={VerifySchema} onSubmit={onSubmit}>
          {({ isSubmitting, errors, values, touched, handleChange, setFieldValue }) => {
            return (
              <Form>
                <NeoInput
                showAsterisk={loginConfig['verifyCodeRequired']}
                  name='otp'
                  text={t(VERIFY_CODE_KEYS.CODE)}
                  mode='onlyNumber'
                  maxLength={4}
                  disabled={isSubmitting}
                  onChange={(value) => {
                    setFieldValue('otp', value?.value)
                  }}
                  placeholder={t(VERIFY_CODE_KEYS.ENTER_CODE)}
                />
                <InputError text={errors.otp} touched={touched.otp} />

                <div style={{ marginTop: 30 }}>
                  {loading === false ? (
                    <NeoButton
                      type='submit'
                      mode='newDesign'
                      text={t(BUTTON_KEYS.SUBMIT)}
                      styles={{ fontSize: 16, width: '312px' }}
                    />
                  ) : null}
                  {loading === true ? renderLoading() : null}
                </div>
              </Form>
            )
          }}
        </Formik> */}
      </div>
      {/* <div style={{ height: 80 }}></div> */}
    </AuthLayout>
  )
}
